module.exports = __webpack_public_path__ + "static/media/vive-create-feature-c.ab5a90c5.png";